/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_7_PInputs */

const en_privacy_7_p = /** @type {(inputs: Privacy_7_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can access, export (PRD as Markdown, project as ZIP), correct and delete your data. If you are in the EU/EEA or UK, you also have the rights granted by the GDPR, including the right to lodge a complaint with a supervisory authority.`)
};

const id_privacy_7_p = /** @type {(inputs: Privacy_7_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamu bisa mengakses, mengekspor (PRD sebagai Markdown, proyek sebagai ZIP), memperbaiki, dan menghapus datamu. Bila kamu berada di UE/EEA atau Inggris, kamu juga memiliki hak-hak sesuai GDPR, termasuk hak mengajukan keluhan ke otoritas pengawas.`)
};

/**
* | output |
* | --- |
* | "You can access, export (PRD as Markdown, project as ZIP), correct and delete your data. If you are in the EU/EEA or UK, you also have the rights granted by t..." |
*
* @param {Privacy_7_PInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const privacy_7_p = /** @type {((inputs?: Privacy_7_PInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_7_PInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_7_p(inputs)
	return en_privacy_7_p(inputs)
});